import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang, t } from '../../context/LanguageContext';
import T from '../../translations/index';
import './footer.css';
import logo from '../../assets/images/logo.png';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = () => {
  const navigate = useNavigate();
  const { lang } = useLang();

  const navLinks = [
    { labelKey: 'footerNavAbout', path: '/about' },
    { labelKey: 'footerNavServices', path: '/services' },
    { labelKey: 'footerNavProjects', path: '/projects' },
    { labelKey: 'footerNavClients', path: '/clients' },
    { labelKey: 'footerNavCareers', path: '/careers' },
    { labelKey: 'footerNavHireUs', path: '/hireus' },
    { labelKey: 'footerNavContact', path: '/contact' },
  ];

  const socialLinks = [
    { icon: <LinkedInIcon />, href: 'https://www.linkedin.com/company/trishivanay', label: 'LinkedIn', color: '#0a66c2' },
    { icon: <TwitterIcon />, href: 'https://twitter.com/trishivanay', label: 'Twitter / X', color: '#1d9bf0' },
    { icon: <FacebookIcon />, href: 'https://www.facebook.com/trishivanay', label: 'Facebook', color: '#1877f2' },
    { icon: <InstagramIcon />, href: 'https://www.instagram.com/trishivanay', label: 'Instagram', color: '#e1306c' },
    { icon: <YouTubeIcon />, href: 'https://www.youtube.com/@trishivanay', label: 'YouTube', color: '#ff0000' },
    { icon: <WhatsAppIcon />, href: 'https://wa.me/916200247745', label: 'WhatsApp', color: '#25d366' },
  ];

  return (
    <footer className="app-footer">
      {/* Top gradient accent */}
      <div className="footer-top-accent" />

      <div className="footer-main">
        {/* Brand column */}
        <div className="footer-brand">
          <div className="footer-logo-row">
            <img src={logo} alt="TCPL Logo" className="footer-logo-img" />
            <div>
              <div className="footer-company-name">Trishivanay Construction</div>
              <div className="footer-company-sub">Private Limited (TCPL)</div>
            </div>
          </div>
          <p className="footer-tagline">
            {t(T.footerTagline, lang)}
          </p>
          <div className="footer-dpiit-badge">
            <span>🇮🇳</span>
            <span>{t(T.footerDpiit, lang)}</span>
          </div>
          <div className="footer-dpiit-badge footer-msme-badge">
            <span>🏭</span>
            <span>{t(T.footerMsme, lang)}</span>
          </div>
        </div>

        {/* Navigation column */}
        <div className="footer-column">
          <h4 className="footer-col-title">{t(T.footerQuickLinks, lang)}</h4>
          <ul className="footer-nav-list">
            {navLinks.map((link) => (
              <li key={link.path}>
                <button className="footer-nav-link" onClick={() => navigate(link.path)}>
                  {t(T[link.labelKey], lang)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact column */}
        <div className="footer-column">
          <h4 className="footer-col-title">{t(T.footerContactUs, lang)}</h4>
          <ul className="footer-contact-list">
            <li>
              <EmailIcon className="footer-contact-icon" />
              <a href="mailto:arunojha@trishivanay.com">arunojha@trishivanay.com</a>
            </li>
            <li>
              <PhoneIcon className="footer-contact-icon" />
              <a href="tel:+916200247745">+91 6200247745</a>
            </li>
            <li>
              <LocationOnIcon className="footer-contact-icon" />
              <span>Shiv Singh Bagan, 23B GTBN,<br />Jamshedpur, Jharkhand — 831009</span>
            </li>
          </ul>
        </div>

        {/* Social column */}
        <div className="footer-column">
          <h4 className="footer-col-title">{t(T.footerFollowUs, lang)}</h4>
          <div className="footer-social-grid">
            {socialLinks.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-btn"
                aria-label={s.label}
                style={{ '--social-color': s.color }}
              >
                {s.icon}
                <span>{s.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} <strong style={{ color: '#fff', fontWeight: 800 }}>Trishivanay Construction Private Limited</strong>. {t(T.footerAllRights, lang)}</span>
        <span className="footer-bottom-divider">|</span>
      <span>{t(T.footerDesignedBy, lang)} <strong style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 700 }}>TrishivaX Mectech Private Limited</strong>, Bangalore, India</span>
      </div>

      {/* TrishivaX Credit Section */}
      <div className="footer-trishivax">
        <div className="footer-trishivax-inner">
          <div className="footer-trishivax-brand">
            <span className="footer-trishivax-logo">TX</span>
            <div>
              <div className="footer-trishivax-name">TrishivaX Mectech Private Limited</div>
              <div className="footer-trishivax-loc">Bangalore, Karnataka, India</div>
            </div>
          </div>
          <div className="footer-trishivax-center">
            <span className="footer-trishivax-label">✦ Designed &amp; Developed by TrishivaX Mectech Pvt. Ltd.</span>
            <a href="mailto:info@trishivax.com" className="footer-trishivax-email">info@trishivax.com</a>
          </div>
          <div className="footer-trishivax-right">
            <span className="footer-trishivax-tech">React · MUI · Node.js</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
